/* tslint:disable */
/* eslint-disable */
/**
 * Abekus Open API Docs
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction, replaceWithSerializableTypeIfNeeded } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap } from '../base';
// @ts-ignore
import type { AddCandidatesByEmailBody } from '../models';
// @ts-ignore
import type { CandidatePerformanceResponse } from '../models';
// @ts-ignore
import type { CandidatesListResponse } from '../models';
// @ts-ignore
import type { ClaimInviteBody } from '../models';
// @ts-ignore
import type { ClaimPreviewResponse } from '../models';
// @ts-ignore
import type { CreateGroupBody } from '../models';
// @ts-ignore
import type { ErrorResponse } from '../models';
// @ts-ignore
import type { GroupResponse } from '../models';
// @ts-ignore
import type { MyPartnersResponse } from '../models';
// @ts-ignore
import type { PartnerCandidateApplicationsResponse } from '../models';
// @ts-ignore
import type { PartnerFunnelResponse } from '../models';
// @ts-ignore
import type { PartnerInsightsResponse } from '../models';
// @ts-ignore
import type { PlacementPartnerOnboardingBody } from '../models';
// @ts-ignore
import type { PlacementPartnerOrg } from '../models';
// @ts-ignore
import type { UpdateGroupBody } from '../models';
// @ts-ignore
import type { VerificationDocPatchBody } from '../models';
/**
 * PlacementPartnerApiApi - axios parameter creator
 */
export const PlacementPartnerApiApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} groupId 
         * @param {string} orgId 
         * @param {AddCandidatesByEmailBody} addCandidatesByEmailBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        placementPartnerApiAddCandidatesByEmail: async (groupId: string, orgId: string, addCandidatesByEmailBody: AddCandidatesByEmailBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'groupId' is not null or undefined
            assertParamExists('placementPartnerApiAddCandidatesByEmail', 'groupId', groupId)
            // verify required parameter 'orgId' is not null or undefined
            assertParamExists('placementPartnerApiAddCandidatesByEmail', 'orgId', orgId)
            // verify required parameter 'addCandidatesByEmailBody' is not null or undefined
            assertParamExists('placementPartnerApiAddCandidatesByEmail', 'addCandidatesByEmailBody', addCandidatesByEmailBody)
            const localVarPath = `/api/v1/placement-partner/orgs/{org_id}/groups/{group_id}/candidates/emails`
                .replace('{group_id}', encodeURIComponent(String(groupId)))
                .replace('{org_id}', encodeURIComponent(String(orgId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(addCandidatesByEmailBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} groupId 
         * @param {string} orgId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        placementPartnerApiAddCandidatesByResume: async (groupId: string, orgId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'groupId' is not null or undefined
            assertParamExists('placementPartnerApiAddCandidatesByResume', 'groupId', groupId)
            // verify required parameter 'orgId' is not null or undefined
            assertParamExists('placementPartnerApiAddCandidatesByResume', 'orgId', orgId)
            const localVarPath = `/api/v1/placement-partner/orgs/{org_id}/groups/{group_id}/candidates/resumes`
                .replace('{group_id}', encodeURIComponent(String(groupId)))
                .replace('{org_id}', encodeURIComponent(String(orgId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} orgId 
         * @param {string} targetUserId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        placementPartnerApiCandidateApplications: async (orgId: string, targetUserId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'orgId' is not null or undefined
            assertParamExists('placementPartnerApiCandidateApplications', 'orgId', orgId)
            // verify required parameter 'targetUserId' is not null or undefined
            assertParamExists('placementPartnerApiCandidateApplications', 'targetUserId', targetUserId)
            const localVarPath = `/api/v1/placement-partner/orgs/{org_id}/candidates/{target_user_id}/applications`
                .replace('{org_id}', encodeURIComponent(String(orgId)))
                .replace('{target_user_id}', encodeURIComponent(String(targetUserId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} orgId 
         * @param {string} targetUserId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        placementPartnerApiCandidatePerformance: async (orgId: string, targetUserId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'orgId' is not null or undefined
            assertParamExists('placementPartnerApiCandidatePerformance', 'orgId', orgId)
            // verify required parameter 'targetUserId' is not null or undefined
            assertParamExists('placementPartnerApiCandidatePerformance', 'targetUserId', targetUserId)
            const localVarPath = `/api/v1/placement-partner/orgs/{org_id}/candidates/{target_user_id}/performance`
                .replace('{org_id}', encodeURIComponent(String(orgId)))
                .replace('{target_user_id}', encodeURIComponent(String(targetUserId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {ClaimInviteBody} claimInviteBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        placementPartnerApiClaimInvite: async (claimInviteBody: ClaimInviteBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'claimInviteBody' is not null or undefined
            assertParamExists('placementPartnerApiClaimInvite', 'claimInviteBody', claimInviteBody)
            const localVarPath = `/api/v1/placement-partner/invite/claim`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(claimInviteBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} orgId 
         * @param {CreateGroupBody} createGroupBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        placementPartnerApiCreateGroup: async (orgId: string, createGroupBody: CreateGroupBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'orgId' is not null or undefined
            assertParamExists('placementPartnerApiCreateGroup', 'orgId', orgId)
            // verify required parameter 'createGroupBody' is not null or undefined
            assertParamExists('placementPartnerApiCreateGroup', 'createGroupBody', createGroupBody)
            const localVarPath = `/api/v1/placement-partner/orgs/{org_id}/groups`
                .replace('{org_id}', encodeURIComponent(String(orgId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createGroupBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} groupId 
         * @param {string} orgId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        placementPartnerApiDeleteGroup: async (groupId: string, orgId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'groupId' is not null or undefined
            assertParamExists('placementPartnerApiDeleteGroup', 'groupId', groupId)
            // verify required parameter 'orgId' is not null or undefined
            assertParamExists('placementPartnerApiDeleteGroup', 'orgId', orgId)
            const localVarPath = `/api/v1/placement-partner/orgs/{org_id}/groups/{group_id}`
                .replace('{group_id}', encodeURIComponent(String(groupId)))
                .replace('{org_id}', encodeURIComponent(String(orgId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} partnerOrgId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        placementPartnerApiLeavePartner: async (partnerOrgId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'partnerOrgId' is not null or undefined
            assertParamExists('placementPartnerApiLeavePartner', 'partnerOrgId', partnerOrgId)
            const localVarPath = `/api/v1/placement-partner/me/partners/{partner_org_id}`
                .replace('{partner_org_id}', encodeURIComponent(String(partnerOrgId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} groupId 
         * @param {string} orgId 
         * @param {number} [page] 
         * @param {number} [pageSize] 
         * @param {string | null} [search] 
         * @param {string | null} [status] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        placementPartnerApiListCandidates: async (groupId: string, orgId: string, page?: number, pageSize?: number, search?: string | null, status?: string | null, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'groupId' is not null or undefined
            assertParamExists('placementPartnerApiListCandidates', 'groupId', groupId)
            // verify required parameter 'orgId' is not null or undefined
            assertParamExists('placementPartnerApiListCandidates', 'orgId', orgId)
            const localVarPath = `/api/v1/placement-partner/orgs/{org_id}/groups/{group_id}/candidates`
                .replace('{group_id}', encodeURIComponent(String(groupId)))
                .replace('{org_id}', encodeURIComponent(String(orgId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (pageSize !== undefined) {
                localVarQueryParameter['page_size'] = pageSize;
            }

            if (search !== undefined) {
                localVarQueryParameter['search'] = search;
            }

            if (status !== undefined) {
                localVarQueryParameter['status'] = status;
            }

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} orgId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        placementPartnerApiListGroups: async (orgId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'orgId' is not null or undefined
            assertParamExists('placementPartnerApiListGroups', 'orgId', orgId)
            const localVarPath = `/api/v1/placement-partner/orgs/{org_id}/groups`
                .replace('{org_id}', encodeURIComponent(String(orgId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        placementPartnerApiListMyPartnerOrgs: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/placement-partner/orgs`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        placementPartnerApiMyPartners: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/placement-partner/me/partners`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} orgId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        placementPartnerApiPartnerFunnel: async (orgId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'orgId' is not null or undefined
            assertParamExists('placementPartnerApiPartnerFunnel', 'orgId', orgId)
            const localVarPath = `/api/v1/placement-partner/orgs/{org_id}/funnel`
                .replace('{org_id}', encodeURIComponent(String(orgId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} orgId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        placementPartnerApiPartnerInsights: async (orgId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'orgId' is not null or undefined
            assertParamExists('placementPartnerApiPartnerInsights', 'orgId', orgId)
            const localVarPath = `/api/v1/placement-partner/orgs/{org_id}/insights`
                .replace('{org_id}', encodeURIComponent(String(orgId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {PlacementPartnerOnboardingBody} placementPartnerOnboardingBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        placementPartnerApiPlacementPartnerOnboarding: async (placementPartnerOnboardingBody: PlacementPartnerOnboardingBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'placementPartnerOnboardingBody' is not null or undefined
            assertParamExists('placementPartnerApiPlacementPartnerOnboarding', 'placementPartnerOnboardingBody', placementPartnerOnboardingBody)
            const localVarPath = `/api/v1/placement-partner/onboarding`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(placementPartnerOnboardingBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} inviteToken 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        placementPartnerApiPreviewInvite: async (inviteToken: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'inviteToken' is not null or undefined
            assertParamExists('placementPartnerApiPreviewInvite', 'inviteToken', inviteToken)
            const localVarPath = `/api/v1/placement-partner/invite/preview`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (inviteToken !== undefined) {
                localVarQueryParameter['invite_token'] = inviteToken;
            }

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} groupId 
         * @param {string} orgId 
         * @param {string} targetUserId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        placementPartnerApiRemoveCandidate: async (groupId: string, orgId: string, targetUserId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'groupId' is not null or undefined
            assertParamExists('placementPartnerApiRemoveCandidate', 'groupId', groupId)
            // verify required parameter 'orgId' is not null or undefined
            assertParamExists('placementPartnerApiRemoveCandidate', 'orgId', orgId)
            // verify required parameter 'targetUserId' is not null or undefined
            assertParamExists('placementPartnerApiRemoveCandidate', 'targetUserId', targetUserId)
            const localVarPath = `/api/v1/placement-partner/orgs/{org_id}/groups/{group_id}/candidates/{target_user_id}`
                .replace('{group_id}', encodeURIComponent(String(groupId)))
                .replace('{org_id}', encodeURIComponent(String(orgId)))
                .replace('{target_user_id}', encodeURIComponent(String(targetUserId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} candidateId 
         * @param {string} groupId 
         * @param {string} orgId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        placementPartnerApiRemoveCandidateRow: async (candidateId: string, groupId: string, orgId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'candidateId' is not null or undefined
            assertParamExists('placementPartnerApiRemoveCandidateRow', 'candidateId', candidateId)
            // verify required parameter 'groupId' is not null or undefined
            assertParamExists('placementPartnerApiRemoveCandidateRow', 'groupId', groupId)
            // verify required parameter 'orgId' is not null or undefined
            assertParamExists('placementPartnerApiRemoveCandidateRow', 'orgId', orgId)
            const localVarPath = `/api/v1/placement-partner/orgs/{org_id}/groups/{group_id}/candidate-rows/{candidate_id}`
                .replace('{candidate_id}', encodeURIComponent(String(candidateId)))
                .replace('{group_id}', encodeURIComponent(String(groupId)))
                .replace('{org_id}', encodeURIComponent(String(orgId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} groupId 
         * @param {string} orgId 
         * @param {string} targetUserId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        placementPartnerApiResendInvite: async (groupId: string, orgId: string, targetUserId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'groupId' is not null or undefined
            assertParamExists('placementPartnerApiResendInvite', 'groupId', groupId)
            // verify required parameter 'orgId' is not null or undefined
            assertParamExists('placementPartnerApiResendInvite', 'orgId', orgId)
            // verify required parameter 'targetUserId' is not null or undefined
            assertParamExists('placementPartnerApiResendInvite', 'targetUserId', targetUserId)
            const localVarPath = `/api/v1/placement-partner/orgs/{org_id}/groups/{group_id}/candidates/{target_user_id}/resend-invite`
                .replace('{group_id}', encodeURIComponent(String(groupId)))
                .replace('{org_id}', encodeURIComponent(String(orgId)))
                .replace('{target_user_id}', encodeURIComponent(String(targetUserId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} orgId 
         * @param {VerificationDocPatchBody} verificationDocPatchBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        placementPartnerApiSetVerificationDoc: async (orgId: string, verificationDocPatchBody: VerificationDocPatchBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'orgId' is not null or undefined
            assertParamExists('placementPartnerApiSetVerificationDoc', 'orgId', orgId)
            // verify required parameter 'verificationDocPatchBody' is not null or undefined
            assertParamExists('placementPartnerApiSetVerificationDoc', 'verificationDocPatchBody', verificationDocPatchBody)
            const localVarPath = `/api/v1/placement-partner/orgs/{org_id}/verification-doc`
                .replace('{org_id}', encodeURIComponent(String(orgId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(verificationDocPatchBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} groupId 
         * @param {string} orgId 
         * @param {UpdateGroupBody} updateGroupBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        placementPartnerApiUpdateGroup: async (groupId: string, orgId: string, updateGroupBody: UpdateGroupBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'groupId' is not null or undefined
            assertParamExists('placementPartnerApiUpdateGroup', 'groupId', groupId)
            // verify required parameter 'orgId' is not null or undefined
            assertParamExists('placementPartnerApiUpdateGroup', 'orgId', orgId)
            // verify required parameter 'updateGroupBody' is not null or undefined
            assertParamExists('placementPartnerApiUpdateGroup', 'updateGroupBody', updateGroupBody)
            const localVarPath = `/api/v1/placement-partner/orgs/{org_id}/groups/{group_id}`
                .replace('{group_id}', encodeURIComponent(String(groupId)))
                .replace('{org_id}', encodeURIComponent(String(orgId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateGroupBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * PlacementPartnerApiApi - functional programming interface
 */
export const PlacementPartnerApiApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = PlacementPartnerApiApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {string} groupId 
         * @param {string} orgId 
         * @param {AddCandidatesByEmailBody} addCandidatesByEmailBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async placementPartnerApiAddCandidatesByEmail(groupId: string, orgId: string, addCandidatesByEmailBody: AddCandidatesByEmailBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.placementPartnerApiAddCandidatesByEmail(groupId, orgId, addCandidatesByEmailBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PlacementPartnerApiApi.placementPartnerApiAddCandidatesByEmail']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} groupId 
         * @param {string} orgId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async placementPartnerApiAddCandidatesByResume(groupId: string, orgId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.placementPartnerApiAddCandidatesByResume(groupId, orgId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PlacementPartnerApiApi.placementPartnerApiAddCandidatesByResume']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} orgId 
         * @param {string} targetUserId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async placementPartnerApiCandidateApplications(orgId: string, targetUserId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PartnerCandidateApplicationsResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.placementPartnerApiCandidateApplications(orgId, targetUserId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PlacementPartnerApiApi.placementPartnerApiCandidateApplications']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} orgId 
         * @param {string} targetUserId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async placementPartnerApiCandidatePerformance(orgId: string, targetUserId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CandidatePerformanceResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.placementPartnerApiCandidatePerformance(orgId, targetUserId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PlacementPartnerApiApi.placementPartnerApiCandidatePerformance']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {ClaimInviteBody} claimInviteBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async placementPartnerApiClaimInvite(claimInviteBody: ClaimInviteBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.placementPartnerApiClaimInvite(claimInviteBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PlacementPartnerApiApi.placementPartnerApiClaimInvite']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} orgId 
         * @param {CreateGroupBody} createGroupBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async placementPartnerApiCreateGroup(orgId: string, createGroupBody: CreateGroupBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GroupResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.placementPartnerApiCreateGroup(orgId, createGroupBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PlacementPartnerApiApi.placementPartnerApiCreateGroup']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} groupId 
         * @param {string} orgId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async placementPartnerApiDeleteGroup(groupId: string, orgId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.placementPartnerApiDeleteGroup(groupId, orgId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PlacementPartnerApiApi.placementPartnerApiDeleteGroup']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} partnerOrgId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async placementPartnerApiLeavePartner(partnerOrgId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.placementPartnerApiLeavePartner(partnerOrgId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PlacementPartnerApiApi.placementPartnerApiLeavePartner']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} groupId 
         * @param {string} orgId 
         * @param {number} [page] 
         * @param {number} [pageSize] 
         * @param {string | null} [search] 
         * @param {string | null} [status] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async placementPartnerApiListCandidates(groupId: string, orgId: string, page?: number, pageSize?: number, search?: string | null, status?: string | null, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CandidatesListResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.placementPartnerApiListCandidates(groupId, orgId, page, pageSize, search, status, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PlacementPartnerApiApi.placementPartnerApiListCandidates']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} orgId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async placementPartnerApiListGroups(orgId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<GroupResponse>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.placementPartnerApiListGroups(orgId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PlacementPartnerApiApi.placementPartnerApiListGroups']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async placementPartnerApiListMyPartnerOrgs(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<PlacementPartnerOrg>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.placementPartnerApiListMyPartnerOrgs(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PlacementPartnerApiApi.placementPartnerApiListMyPartnerOrgs']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async placementPartnerApiMyPartners(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<MyPartnersResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.placementPartnerApiMyPartners(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PlacementPartnerApiApi.placementPartnerApiMyPartners']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} orgId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async placementPartnerApiPartnerFunnel(orgId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PartnerFunnelResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.placementPartnerApiPartnerFunnel(orgId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PlacementPartnerApiApi.placementPartnerApiPartnerFunnel']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} orgId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async placementPartnerApiPartnerInsights(orgId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PartnerInsightsResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.placementPartnerApiPartnerInsights(orgId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PlacementPartnerApiApi.placementPartnerApiPartnerInsights']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {PlacementPartnerOnboardingBody} placementPartnerOnboardingBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async placementPartnerApiPlacementPartnerOnboarding(placementPartnerOnboardingBody: PlacementPartnerOnboardingBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PlacementPartnerOrg>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.placementPartnerApiPlacementPartnerOnboarding(placementPartnerOnboardingBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PlacementPartnerApiApi.placementPartnerApiPlacementPartnerOnboarding']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} inviteToken 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async placementPartnerApiPreviewInvite(inviteToken: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ClaimPreviewResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.placementPartnerApiPreviewInvite(inviteToken, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PlacementPartnerApiApi.placementPartnerApiPreviewInvite']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} groupId 
         * @param {string} orgId 
         * @param {string} targetUserId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async placementPartnerApiRemoveCandidate(groupId: string, orgId: string, targetUserId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.placementPartnerApiRemoveCandidate(groupId, orgId, targetUserId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PlacementPartnerApiApi.placementPartnerApiRemoveCandidate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} candidateId 
         * @param {string} groupId 
         * @param {string} orgId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async placementPartnerApiRemoveCandidateRow(candidateId: string, groupId: string, orgId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.placementPartnerApiRemoveCandidateRow(candidateId, groupId, orgId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PlacementPartnerApiApi.placementPartnerApiRemoveCandidateRow']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} groupId 
         * @param {string} orgId 
         * @param {string} targetUserId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async placementPartnerApiResendInvite(groupId: string, orgId: string, targetUserId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.placementPartnerApiResendInvite(groupId, orgId, targetUserId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PlacementPartnerApiApi.placementPartnerApiResendInvite']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} orgId 
         * @param {VerificationDocPatchBody} verificationDocPatchBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async placementPartnerApiSetVerificationDoc(orgId: string, verificationDocPatchBody: VerificationDocPatchBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PlacementPartnerOrg>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.placementPartnerApiSetVerificationDoc(orgId, verificationDocPatchBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PlacementPartnerApiApi.placementPartnerApiSetVerificationDoc']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} groupId 
         * @param {string} orgId 
         * @param {UpdateGroupBody} updateGroupBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async placementPartnerApiUpdateGroup(groupId: string, orgId: string, updateGroupBody: UpdateGroupBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GroupResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.placementPartnerApiUpdateGroup(groupId, orgId, updateGroupBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PlacementPartnerApiApi.placementPartnerApiUpdateGroup']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * PlacementPartnerApiApi - factory interface
 */
export const PlacementPartnerApiApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = PlacementPartnerApiApiFp(configuration)
    return {
        /**
         * 
         * @param {PlacementPartnerApiApiPlacementPartnerApiAddCandidatesByEmailRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        placementPartnerApiAddCandidatesByEmail(requestParameters: PlacementPartnerApiApiPlacementPartnerApiAddCandidatesByEmailRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.placementPartnerApiAddCandidatesByEmail(requestParameters.groupId, requestParameters.orgId, requestParameters.addCandidatesByEmailBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {PlacementPartnerApiApiPlacementPartnerApiAddCandidatesByResumeRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        placementPartnerApiAddCandidatesByResume(requestParameters: PlacementPartnerApiApiPlacementPartnerApiAddCandidatesByResumeRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.placementPartnerApiAddCandidatesByResume(requestParameters.groupId, requestParameters.orgId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {PlacementPartnerApiApiPlacementPartnerApiCandidateApplicationsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        placementPartnerApiCandidateApplications(requestParameters: PlacementPartnerApiApiPlacementPartnerApiCandidateApplicationsRequest, options?: RawAxiosRequestConfig): AxiosPromise<PartnerCandidateApplicationsResponse> {
            return localVarFp.placementPartnerApiCandidateApplications(requestParameters.orgId, requestParameters.targetUserId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {PlacementPartnerApiApiPlacementPartnerApiCandidatePerformanceRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        placementPartnerApiCandidatePerformance(requestParameters: PlacementPartnerApiApiPlacementPartnerApiCandidatePerformanceRequest, options?: RawAxiosRequestConfig): AxiosPromise<CandidatePerformanceResponse> {
            return localVarFp.placementPartnerApiCandidatePerformance(requestParameters.orgId, requestParameters.targetUserId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {PlacementPartnerApiApiPlacementPartnerApiClaimInviteRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        placementPartnerApiClaimInvite(requestParameters: PlacementPartnerApiApiPlacementPartnerApiClaimInviteRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.placementPartnerApiClaimInvite(requestParameters.claimInviteBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {PlacementPartnerApiApiPlacementPartnerApiCreateGroupRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        placementPartnerApiCreateGroup(requestParameters: PlacementPartnerApiApiPlacementPartnerApiCreateGroupRequest, options?: RawAxiosRequestConfig): AxiosPromise<GroupResponse> {
            return localVarFp.placementPartnerApiCreateGroup(requestParameters.orgId, requestParameters.createGroupBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {PlacementPartnerApiApiPlacementPartnerApiDeleteGroupRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        placementPartnerApiDeleteGroup(requestParameters: PlacementPartnerApiApiPlacementPartnerApiDeleteGroupRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.placementPartnerApiDeleteGroup(requestParameters.groupId, requestParameters.orgId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {PlacementPartnerApiApiPlacementPartnerApiLeavePartnerRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        placementPartnerApiLeavePartner(requestParameters: PlacementPartnerApiApiPlacementPartnerApiLeavePartnerRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.placementPartnerApiLeavePartner(requestParameters.partnerOrgId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {PlacementPartnerApiApiPlacementPartnerApiListCandidatesRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        placementPartnerApiListCandidates(requestParameters: PlacementPartnerApiApiPlacementPartnerApiListCandidatesRequest, options?: RawAxiosRequestConfig): AxiosPromise<CandidatesListResponse> {
            return localVarFp.placementPartnerApiListCandidates(requestParameters.groupId, requestParameters.orgId, requestParameters.page, requestParameters.pageSize, requestParameters.search, requestParameters.status, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {PlacementPartnerApiApiPlacementPartnerApiListGroupsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        placementPartnerApiListGroups(requestParameters: PlacementPartnerApiApiPlacementPartnerApiListGroupsRequest, options?: RawAxiosRequestConfig): AxiosPromise<Array<GroupResponse>> {
            return localVarFp.placementPartnerApiListGroups(requestParameters.orgId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        placementPartnerApiListMyPartnerOrgs(options?: RawAxiosRequestConfig): AxiosPromise<Array<PlacementPartnerOrg>> {
            return localVarFp.placementPartnerApiListMyPartnerOrgs(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        placementPartnerApiMyPartners(options?: RawAxiosRequestConfig): AxiosPromise<MyPartnersResponse> {
            return localVarFp.placementPartnerApiMyPartners(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {PlacementPartnerApiApiPlacementPartnerApiPartnerFunnelRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        placementPartnerApiPartnerFunnel(requestParameters: PlacementPartnerApiApiPlacementPartnerApiPartnerFunnelRequest, options?: RawAxiosRequestConfig): AxiosPromise<PartnerFunnelResponse> {
            return localVarFp.placementPartnerApiPartnerFunnel(requestParameters.orgId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {PlacementPartnerApiApiPlacementPartnerApiPartnerInsightsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        placementPartnerApiPartnerInsights(requestParameters: PlacementPartnerApiApiPlacementPartnerApiPartnerInsightsRequest, options?: RawAxiosRequestConfig): AxiosPromise<PartnerInsightsResponse> {
            return localVarFp.placementPartnerApiPartnerInsights(requestParameters.orgId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {PlacementPartnerApiApiPlacementPartnerApiPlacementPartnerOnboardingRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        placementPartnerApiPlacementPartnerOnboarding(requestParameters: PlacementPartnerApiApiPlacementPartnerApiPlacementPartnerOnboardingRequest, options?: RawAxiosRequestConfig): AxiosPromise<PlacementPartnerOrg> {
            return localVarFp.placementPartnerApiPlacementPartnerOnboarding(requestParameters.placementPartnerOnboardingBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {PlacementPartnerApiApiPlacementPartnerApiPreviewInviteRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        placementPartnerApiPreviewInvite(requestParameters: PlacementPartnerApiApiPlacementPartnerApiPreviewInviteRequest, options?: RawAxiosRequestConfig): AxiosPromise<ClaimPreviewResponse> {
            return localVarFp.placementPartnerApiPreviewInvite(requestParameters.inviteToken, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {PlacementPartnerApiApiPlacementPartnerApiRemoveCandidateRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        placementPartnerApiRemoveCandidate(requestParameters: PlacementPartnerApiApiPlacementPartnerApiRemoveCandidateRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.placementPartnerApiRemoveCandidate(requestParameters.groupId, requestParameters.orgId, requestParameters.targetUserId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {PlacementPartnerApiApiPlacementPartnerApiRemoveCandidateRowRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        placementPartnerApiRemoveCandidateRow(requestParameters: PlacementPartnerApiApiPlacementPartnerApiRemoveCandidateRowRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.placementPartnerApiRemoveCandidateRow(requestParameters.candidateId, requestParameters.groupId, requestParameters.orgId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {PlacementPartnerApiApiPlacementPartnerApiResendInviteRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        placementPartnerApiResendInvite(requestParameters: PlacementPartnerApiApiPlacementPartnerApiResendInviteRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.placementPartnerApiResendInvite(requestParameters.groupId, requestParameters.orgId, requestParameters.targetUserId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {PlacementPartnerApiApiPlacementPartnerApiSetVerificationDocRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        placementPartnerApiSetVerificationDoc(requestParameters: PlacementPartnerApiApiPlacementPartnerApiSetVerificationDocRequest, options?: RawAxiosRequestConfig): AxiosPromise<PlacementPartnerOrg> {
            return localVarFp.placementPartnerApiSetVerificationDoc(requestParameters.orgId, requestParameters.verificationDocPatchBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {PlacementPartnerApiApiPlacementPartnerApiUpdateGroupRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        placementPartnerApiUpdateGroup(requestParameters: PlacementPartnerApiApiPlacementPartnerApiUpdateGroupRequest, options?: RawAxiosRequestConfig): AxiosPromise<GroupResponse> {
            return localVarFp.placementPartnerApiUpdateGroup(requestParameters.groupId, requestParameters.orgId, requestParameters.updateGroupBody, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for placementPartnerApiAddCandidatesByEmail operation in PlacementPartnerApiApi.
 */
export interface PlacementPartnerApiApiPlacementPartnerApiAddCandidatesByEmailRequest {
    readonly groupId: string

    readonly orgId: string

    readonly addCandidatesByEmailBody: AddCandidatesByEmailBody
}

/**
 * Request parameters for placementPartnerApiAddCandidatesByResume operation in PlacementPartnerApiApi.
 */
export interface PlacementPartnerApiApiPlacementPartnerApiAddCandidatesByResumeRequest {
    readonly groupId: string

    readonly orgId: string
}

/**
 * Request parameters for placementPartnerApiCandidateApplications operation in PlacementPartnerApiApi.
 */
export interface PlacementPartnerApiApiPlacementPartnerApiCandidateApplicationsRequest {
    readonly orgId: string

    readonly targetUserId: string
}

/**
 * Request parameters for placementPartnerApiCandidatePerformance operation in PlacementPartnerApiApi.
 */
export interface PlacementPartnerApiApiPlacementPartnerApiCandidatePerformanceRequest {
    readonly orgId: string

    readonly targetUserId: string
}

/**
 * Request parameters for placementPartnerApiClaimInvite operation in PlacementPartnerApiApi.
 */
export interface PlacementPartnerApiApiPlacementPartnerApiClaimInviteRequest {
    readonly claimInviteBody: ClaimInviteBody
}

/**
 * Request parameters for placementPartnerApiCreateGroup operation in PlacementPartnerApiApi.
 */
export interface PlacementPartnerApiApiPlacementPartnerApiCreateGroupRequest {
    readonly orgId: string

    readonly createGroupBody: CreateGroupBody
}

/**
 * Request parameters for placementPartnerApiDeleteGroup operation in PlacementPartnerApiApi.
 */
export interface PlacementPartnerApiApiPlacementPartnerApiDeleteGroupRequest {
    readonly groupId: string

    readonly orgId: string
}

/**
 * Request parameters for placementPartnerApiLeavePartner operation in PlacementPartnerApiApi.
 */
export interface PlacementPartnerApiApiPlacementPartnerApiLeavePartnerRequest {
    readonly partnerOrgId: string
}

/**
 * Request parameters for placementPartnerApiListCandidates operation in PlacementPartnerApiApi.
 */
export interface PlacementPartnerApiApiPlacementPartnerApiListCandidatesRequest {
    readonly groupId: string

    readonly orgId: string

    readonly page?: number

    readonly pageSize?: number

    readonly search?: string | null

    readonly status?: string | null
}

/**
 * Request parameters for placementPartnerApiListGroups operation in PlacementPartnerApiApi.
 */
export interface PlacementPartnerApiApiPlacementPartnerApiListGroupsRequest {
    readonly orgId: string
}

/**
 * Request parameters for placementPartnerApiPartnerFunnel operation in PlacementPartnerApiApi.
 */
export interface PlacementPartnerApiApiPlacementPartnerApiPartnerFunnelRequest {
    readonly orgId: string
}

/**
 * Request parameters for placementPartnerApiPartnerInsights operation in PlacementPartnerApiApi.
 */
export interface PlacementPartnerApiApiPlacementPartnerApiPartnerInsightsRequest {
    readonly orgId: string
}

/**
 * Request parameters for placementPartnerApiPlacementPartnerOnboarding operation in PlacementPartnerApiApi.
 */
export interface PlacementPartnerApiApiPlacementPartnerApiPlacementPartnerOnboardingRequest {
    readonly placementPartnerOnboardingBody: PlacementPartnerOnboardingBody
}

/**
 * Request parameters for placementPartnerApiPreviewInvite operation in PlacementPartnerApiApi.
 */
export interface PlacementPartnerApiApiPlacementPartnerApiPreviewInviteRequest {
    readonly inviteToken: string
}

/**
 * Request parameters for placementPartnerApiRemoveCandidate operation in PlacementPartnerApiApi.
 */
export interface PlacementPartnerApiApiPlacementPartnerApiRemoveCandidateRequest {
    readonly groupId: string

    readonly orgId: string

    readonly targetUserId: string
}

/**
 * Request parameters for placementPartnerApiRemoveCandidateRow operation in PlacementPartnerApiApi.
 */
export interface PlacementPartnerApiApiPlacementPartnerApiRemoveCandidateRowRequest {
    readonly candidateId: string

    readonly groupId: string

    readonly orgId: string
}

/**
 * Request parameters for placementPartnerApiResendInvite operation in PlacementPartnerApiApi.
 */
export interface PlacementPartnerApiApiPlacementPartnerApiResendInviteRequest {
    readonly groupId: string

    readonly orgId: string

    readonly targetUserId: string
}

/**
 * Request parameters for placementPartnerApiSetVerificationDoc operation in PlacementPartnerApiApi.
 */
export interface PlacementPartnerApiApiPlacementPartnerApiSetVerificationDocRequest {
    readonly orgId: string

    readonly verificationDocPatchBody: VerificationDocPatchBody
}

/**
 * Request parameters for placementPartnerApiUpdateGroup operation in PlacementPartnerApiApi.
 */
export interface PlacementPartnerApiApiPlacementPartnerApiUpdateGroupRequest {
    readonly groupId: string

    readonly orgId: string

    readonly updateGroupBody: UpdateGroupBody
}

/**
 * PlacementPartnerApiApi - object-oriented interface
 */
export class PlacementPartnerApiApi extends BaseAPI {
    /**
     * 
     * @param {PlacementPartnerApiApiPlacementPartnerApiAddCandidatesByEmailRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public placementPartnerApiAddCandidatesByEmail(requestParameters: PlacementPartnerApiApiPlacementPartnerApiAddCandidatesByEmailRequest, options?: RawAxiosRequestConfig) {
        return PlacementPartnerApiApiFp(this.configuration).placementPartnerApiAddCandidatesByEmail(requestParameters.groupId, requestParameters.orgId, requestParameters.addCandidatesByEmailBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {PlacementPartnerApiApiPlacementPartnerApiAddCandidatesByResumeRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public placementPartnerApiAddCandidatesByResume(requestParameters: PlacementPartnerApiApiPlacementPartnerApiAddCandidatesByResumeRequest, options?: RawAxiosRequestConfig) {
        return PlacementPartnerApiApiFp(this.configuration).placementPartnerApiAddCandidatesByResume(requestParameters.groupId, requestParameters.orgId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {PlacementPartnerApiApiPlacementPartnerApiCandidateApplicationsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public placementPartnerApiCandidateApplications(requestParameters: PlacementPartnerApiApiPlacementPartnerApiCandidateApplicationsRequest, options?: RawAxiosRequestConfig) {
        return PlacementPartnerApiApiFp(this.configuration).placementPartnerApiCandidateApplications(requestParameters.orgId, requestParameters.targetUserId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {PlacementPartnerApiApiPlacementPartnerApiCandidatePerformanceRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public placementPartnerApiCandidatePerformance(requestParameters: PlacementPartnerApiApiPlacementPartnerApiCandidatePerformanceRequest, options?: RawAxiosRequestConfig) {
        return PlacementPartnerApiApiFp(this.configuration).placementPartnerApiCandidatePerformance(requestParameters.orgId, requestParameters.targetUserId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {PlacementPartnerApiApiPlacementPartnerApiClaimInviteRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public placementPartnerApiClaimInvite(requestParameters: PlacementPartnerApiApiPlacementPartnerApiClaimInviteRequest, options?: RawAxiosRequestConfig) {
        return PlacementPartnerApiApiFp(this.configuration).placementPartnerApiClaimInvite(requestParameters.claimInviteBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {PlacementPartnerApiApiPlacementPartnerApiCreateGroupRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public placementPartnerApiCreateGroup(requestParameters: PlacementPartnerApiApiPlacementPartnerApiCreateGroupRequest, options?: RawAxiosRequestConfig) {
        return PlacementPartnerApiApiFp(this.configuration).placementPartnerApiCreateGroup(requestParameters.orgId, requestParameters.createGroupBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {PlacementPartnerApiApiPlacementPartnerApiDeleteGroupRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public placementPartnerApiDeleteGroup(requestParameters: PlacementPartnerApiApiPlacementPartnerApiDeleteGroupRequest, options?: RawAxiosRequestConfig) {
        return PlacementPartnerApiApiFp(this.configuration).placementPartnerApiDeleteGroup(requestParameters.groupId, requestParameters.orgId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {PlacementPartnerApiApiPlacementPartnerApiLeavePartnerRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public placementPartnerApiLeavePartner(requestParameters: PlacementPartnerApiApiPlacementPartnerApiLeavePartnerRequest, options?: RawAxiosRequestConfig) {
        return PlacementPartnerApiApiFp(this.configuration).placementPartnerApiLeavePartner(requestParameters.partnerOrgId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {PlacementPartnerApiApiPlacementPartnerApiListCandidatesRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public placementPartnerApiListCandidates(requestParameters: PlacementPartnerApiApiPlacementPartnerApiListCandidatesRequest, options?: RawAxiosRequestConfig) {
        return PlacementPartnerApiApiFp(this.configuration).placementPartnerApiListCandidates(requestParameters.groupId, requestParameters.orgId, requestParameters.page, requestParameters.pageSize, requestParameters.search, requestParameters.status, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {PlacementPartnerApiApiPlacementPartnerApiListGroupsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public placementPartnerApiListGroups(requestParameters: PlacementPartnerApiApiPlacementPartnerApiListGroupsRequest, options?: RawAxiosRequestConfig) {
        return PlacementPartnerApiApiFp(this.configuration).placementPartnerApiListGroups(requestParameters.orgId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public placementPartnerApiListMyPartnerOrgs(options?: RawAxiosRequestConfig) {
        return PlacementPartnerApiApiFp(this.configuration).placementPartnerApiListMyPartnerOrgs(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public placementPartnerApiMyPartners(options?: RawAxiosRequestConfig) {
        return PlacementPartnerApiApiFp(this.configuration).placementPartnerApiMyPartners(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {PlacementPartnerApiApiPlacementPartnerApiPartnerFunnelRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public placementPartnerApiPartnerFunnel(requestParameters: PlacementPartnerApiApiPlacementPartnerApiPartnerFunnelRequest, options?: RawAxiosRequestConfig) {
        return PlacementPartnerApiApiFp(this.configuration).placementPartnerApiPartnerFunnel(requestParameters.orgId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {PlacementPartnerApiApiPlacementPartnerApiPartnerInsightsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public placementPartnerApiPartnerInsights(requestParameters: PlacementPartnerApiApiPlacementPartnerApiPartnerInsightsRequest, options?: RawAxiosRequestConfig) {
        return PlacementPartnerApiApiFp(this.configuration).placementPartnerApiPartnerInsights(requestParameters.orgId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {PlacementPartnerApiApiPlacementPartnerApiPlacementPartnerOnboardingRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public placementPartnerApiPlacementPartnerOnboarding(requestParameters: PlacementPartnerApiApiPlacementPartnerApiPlacementPartnerOnboardingRequest, options?: RawAxiosRequestConfig) {
        return PlacementPartnerApiApiFp(this.configuration).placementPartnerApiPlacementPartnerOnboarding(requestParameters.placementPartnerOnboardingBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {PlacementPartnerApiApiPlacementPartnerApiPreviewInviteRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public placementPartnerApiPreviewInvite(requestParameters: PlacementPartnerApiApiPlacementPartnerApiPreviewInviteRequest, options?: RawAxiosRequestConfig) {
        return PlacementPartnerApiApiFp(this.configuration).placementPartnerApiPreviewInvite(requestParameters.inviteToken, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {PlacementPartnerApiApiPlacementPartnerApiRemoveCandidateRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public placementPartnerApiRemoveCandidate(requestParameters: PlacementPartnerApiApiPlacementPartnerApiRemoveCandidateRequest, options?: RawAxiosRequestConfig) {
        return PlacementPartnerApiApiFp(this.configuration).placementPartnerApiRemoveCandidate(requestParameters.groupId, requestParameters.orgId, requestParameters.targetUserId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {PlacementPartnerApiApiPlacementPartnerApiRemoveCandidateRowRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public placementPartnerApiRemoveCandidateRow(requestParameters: PlacementPartnerApiApiPlacementPartnerApiRemoveCandidateRowRequest, options?: RawAxiosRequestConfig) {
        return PlacementPartnerApiApiFp(this.configuration).placementPartnerApiRemoveCandidateRow(requestParameters.candidateId, requestParameters.groupId, requestParameters.orgId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {PlacementPartnerApiApiPlacementPartnerApiResendInviteRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public placementPartnerApiResendInvite(requestParameters: PlacementPartnerApiApiPlacementPartnerApiResendInviteRequest, options?: RawAxiosRequestConfig) {
        return PlacementPartnerApiApiFp(this.configuration).placementPartnerApiResendInvite(requestParameters.groupId, requestParameters.orgId, requestParameters.targetUserId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {PlacementPartnerApiApiPlacementPartnerApiSetVerificationDocRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public placementPartnerApiSetVerificationDoc(requestParameters: PlacementPartnerApiApiPlacementPartnerApiSetVerificationDocRequest, options?: RawAxiosRequestConfig) {
        return PlacementPartnerApiApiFp(this.configuration).placementPartnerApiSetVerificationDoc(requestParameters.orgId, requestParameters.verificationDocPatchBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {PlacementPartnerApiApiPlacementPartnerApiUpdateGroupRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public placementPartnerApiUpdateGroup(requestParameters: PlacementPartnerApiApiPlacementPartnerApiUpdateGroupRequest, options?: RawAxiosRequestConfig) {
        return PlacementPartnerApiApiFp(this.configuration).placementPartnerApiUpdateGroup(requestParameters.groupId, requestParameters.orgId, requestParameters.updateGroupBody, options).then((request) => request(this.axios, this.basePath));
    }
}

